export const ACTION_TYPES = Object.freeze({
    REQ: "required",
    NOTIND: "not indicated",
    OPT: "optional",
    ALT: "alternative",
    CONTRA: "contraindicated", /* not used for pilot study */
    UNNEC: "unnecessary", /* not used for pilot study */
    IRR: "irrelevent", /* not used for pilot study */   
})


export const WAIT_TIFF = "WAITING FOR FEEDBACK FROM TIFFANY"

export const WAIT_SANDY = "PLACEHOLDER"

export const SUM_NODE_NO_FEEDBACK = "SUMMARY NODE WITH NO FEEDBACK"

export const NO_FEEDBACK = "NO FEEDBACK PROVIDED"

export const SUM_NODE_FBCK_CHILDREN = "SUMMARY NODE. NO FEEDBACK BECAUSE CHILDREN ARE SHOWN WITH FEEDBACK"

// to make use of
// import {ACTION_TYPES, WAIT_TIFF, WAIT_SANDY} from "./constants"
